import React, { useState } from "react";
import BarChart from "../BarChart";
import "./index.scss";
import numeral from "numeral";
import { Collapse } from "reactstrap";
import SwitchButton from "components/SwitchButton";
const AnimatedNumber = require("react-animated-number");

type MapWidgetProps = {
  layoutItem: any;
};

const MapWidget = ({ layoutItem }: MapWidgetProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const {
    data,
    type,
    title,
    keyAttribute,
    valueAttribute,
    fromColor,
    toColor,
    unit,
    toggleActions,
    id,
    description,
    action,
    defaultChecked,
    customBody,
    customBottomComponent,
    buttonActions,
    loading,
  } = layoutItem;
  let body = null;
  if (type == "single_number") {
    // body = (
    //   <span className="map-widget__body-main-text">
    //     {numeral(data).format("0,0")}{" "}
    //     <span className="map-widget__body-unit-text">{unit}</span>
    //   </span>
    // );
    body = (
      <AnimatedNumber
        component="text"
        value={data}
        style={{
          transition: "0.8s ease-out",
          fontSize: 24,
          fontWeight: "bold",
          color: "var(--color-orange)",
        }}
        duration={300}
        formatValue={(n: any) => numeral(n).format("0,0")}
      />
    );
  } else if (type == "bar_chart") {
    body = (
      <BarChart
        keyAttribute={keyAttribute}
        rawDataArray={data}
        valueAttribute={valueAttribute}
        fromColor={fromColor}
        toColor={toColor}
      />
    );
  } else if (type == "custom_body") {
    body = customBody;
  }
  const toggle = () => setIsOpen(!isOpen);
  const renderToggleFooter = (item: any) => {
    return (
      <div className="map-widget__footer-item" key={`${id}-${item.label}`}>
        <span>{item.label}</span>
        <SwitchButton checked={item.defaultChecked} onChange={item.action} />
      </div>
    );
  };

  const renderButtonFooter = (item: any) => {
    return (
      <div
        className="map-widget__footer-item normal-button"
        key={`${id}-${item.label}`}
        onClick={item.action}
      >
        <span className="footer-button">{item.label}</span>
      </div>
    );
  };

  if (type == "single_toggle") {
    return (
      <div className="map-widget__container">
        <div className="map-widget__header-toggle__wrapper">
          <div className="map-widget__header-toggle">
            <span className="map-widget__title">{title}</span>
            <SwitchButton onChange={action} checked={defaultChecked} />
          </div>
          {description && defaultChecked && (
            <span className="map-widget__description">{description}</span>
          )}
        </div>
        {customBottomComponent}
        {buttonActions?.length > 0 && (
          <div className="map-widget__footer">
            {buttonActions?.map?.(renderButtonFooter)}
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="map-widget__container">
      <div
        className={`site-planning__sidebar-data-widget-is-loading-data ${
          loading ? "active" : ""
        }`}
      />
      <div className="map-widget__header normal-button" onClick={toggle}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span className="map-widget__title">{title}</span>
          {description && (
            <span className="map-widget__description">{description}</span>
          )}
        </div>
        <i className="material-icons">
          {isOpen ? "expand_less" : "expand_more"}
        </i>
      </div>
      <Collapse isOpen={isOpen}>
        <>
          <div className="map-widget__separate-line" />
          <div className="map-widget__body">{body}</div>
          {toggleActions?.length > 0 && (
            <div className="map-widget__footer">
              {toggleActions?.map?.(renderToggleFooter)}
            </div>
          )}
          {buttonActions?.length > 0 && (
            <div className="map-widget__footer">
              {buttonActions?.map?.(renderButtonFooter)}
            </div>
          )}
          {customBottomComponent && (
            <div className="map-widget__footer">{customBottomComponent}</div>
          )}
        </>
      </Collapse>
    </div>
  );
};

export default MapWidget;
